import TabsElementMetaData from '../TabsElement/TabsElementMetaData';

export default {
  type: 'editor.elements.MobileTabsElement',
  name: 'Tabs',
  icon: TabsElementMetaData.icon,
  order: 40
};
